import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { retryFn } from 'shared'
import type { AllocationResponse, BudgetResponse, BudgetWithIds } from 'typings'
import { useFetch } from '../useFetch'
import { BudgetMapper } from './BudgetMapper'
import { BUDGET_URL } from './constants'

type Response = BudgetWithIds

type Props = {
  id: string
  allocationId: string
  options?: Partial<UseQueryOptions<Response>>
}

export function useBudgetQuery(props: Props) {
  const { id, allocationId, options } = props
  const { fetcherWrapper } = useFetch()

  const budgetUrl = new URL(`${BUDGET_URL}/${id}`, window.location.origin)
  const allocationUrl = new URL(
    `${BUDGET_URL}/${id}/allocation/${allocationId}`,
    window.location.origin
  )

  function fetcher() {
    return Promise.all([
      fetcherWrapper(budgetUrl).then((r) => r.json()),
      fetcherWrapper(allocationUrl).then((r) => r.json()),
    ]).then(([budgetResponse, allocationResponse]: [BudgetResponse, AllocationResponse]) =>
      BudgetMapper.fromAPI(
        budgetResponse,
        allocationResponse
      )
    )
  }

  return useQuery({
    queryKey: [`budget-${id}`, allocationId],
    queryFn: fetcher,
    retry: (failureCount, error: any) =>
      retryFn({ params: { failureCount, error }, stopErrors: [403, 404] }),
    ...options,
  })
}
